module.exports = __webpack_public_path__ + "static/media/circle-x.47cf28ab.svg";